import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

export function getOAuth2Config(_configService: ConfigService) {
  return {
    appId: _configService.settings.azureAD.clientId,
    authorizationBaseUrl: `https://login.microsoftonline.com/${_configService.settings.azureAD.tenantId}/oauth2/v2.0/authorize`,
    accessTokenEndpoint: `https://login.microsoftonline.com/${_configService.settings.azureAD.tenantId}/oauth2/v2.0/token`,
    scope: _configService.settings.azureAD.scope,
    responseType: 'token',
    web: {
      redirectUrl: `${_configService.settings.apiUrl}/api/account/auth-success`
    },
    android: {
      pkceEnabled: true,
      responseType: 'code',
      redirectUrl: 'br.com.tg4.performance.btgpactual://login',
      accessTokenEndpoint: `https://login.microsoftonline.com/${_configService.settings.azureAD.tenantId}/oauth2/v2.0/token`,
      handleResultOnNewIntent: true,
      handleResultOnActivityResult: true
    },
    ios: {
      pkceEnabled: true,
      responseType: 'code',
      redirectUrl: 'com.btgpactual.performanceapp://login',
      accessTokenEndpoint: `https://login.microsoftonline.com/${_configService.settings.azureAD.tenantId}/oauth2/v2.0/token`,
    }
  };
}


